import BossBabyPromptTemplateList from "./List";
import BossBabyCreatePromptTemplate from "./Create";
import BossBabyPromptTemplateDetail from "./Detail";

export default {
  List: BossBabyPromptTemplateList,
  Create: BossBabyCreatePromptTemplate,
  Detail: BossBabyPromptTemplateDetail,
};









